// extracted by mini-css-extract-plugin
export default {"breadcrumbContainer":"styles_breadcrumbContainer__v69jN","totalsLabel":"styles_totalsLabel__ryFUt","filters":"styles_filters__9SQ1A","commonFilter":"styles_commonFilter__wLu4R"};